import React from 'react';

import { Badge, Icon } from '@sravni/react-design-system';
import { Crown } from '@sravni/react-icons';

import { Winner } from '../../data';

import styles from './bage-icon.module.scss';

interface IBageIconProps {
  content: Winner[];
}

export const BageIcon: React.FC<IBageIconProps> = ({ content }) => (
  <Badge variant="primary" color="green" text={content.length}>
    <div className={styles.iconWrapper}>
      <Icon icon={<Crown color="var(--color-G100)" />} />
    </div>
  </Badge>
);
